import { CommApiInstance } from "Utils/CommApiInstance";


const MembEmlAddrChngApi = async (
    emlAddr:string,
    emlNtfyYn:string,
) => {
    return await CommApiInstance.post(`memb/eml_addr/chng`,{
        apiBody: {
            emlAddr:emlAddr,
            emlNtfyRecvYn:emlNtfyYn
        }
    })
    .then((Resp) => Resp.data);
}

export default MembEmlAddrChngApi;